import { INPUT_MASK } from 'constants/masks'
import moment, { Moment } from 'moment'

interface formatDateProps {
  date: string | Date | Moment
  inputFormat: string | string[]
  outputFormat: string
}

export const formatDate = ({
  date,
  inputFormat,
  outputFormat,
}: formatDateProps) => moment(date, inputFormat, true).format(outputFormat)

export const formatUtcToBrasilia = (
  value?: string,
  outputFormat: string = INPUT_MASK.DATE_LOCALE_WITH_TIME,
): string => {
  if (!value) {
    return ''
  }

  return moment(value, INPUT_MASK.DATE_LOCALE_WITH_TIME)
    .subtract(3, 'hours')
    .format(outputFormat)
}
